<template>
  <svg
    fill="none"
    height="14"
    viewBox="0 0 16 16"
    width="14"
  >
    <path
      d="M15.0005 0.999886L1.00046 14.9999M1.00046 0.999886L15.0005 14.9999"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
  </svg>
</template>
